import React from 'react';
import { Locale } from '@wordquest/locales';

export const LocaleContext = React.createContext({
  toggleLocale: (targetLocale) => {},
  currentLocale: Locale
});
